function InitilaizeStreets() {
    $('.street-city').prop('disabled', true);
    $('.street-state').change(function() {
        GetFilterValues(this, 'street-city-option');
        $('<option value="">Select a City</option>').prependTo('#street-city-option');
        $('.street-city').prop('disabled', false);
    });

    $('.street-go').click(function() {
        $.DotComAjax({
            url: "/Ajax/GetStreetsResults",
            cache: false,
            dataType: 'html',
            success: function (data) {
                $('.streets-results-section').html('');
                $('.streets-results-section').append(data);
            },
            async: true,
            type: 'post',
            data: $('#StreetsControl').serialize()
        });
    });
}